// Carry only explicit campaign attribution through tour city navigation.
// Avoid copying unrelated query parameters from incoming links.
const TRACKING_KEYS = ["ref", "utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function tourCityHref(citySlug, search) {
  const source = new URLSearchParams(search ?? (typeof window !== "undefined" ? window.location.search : ""));
  const tracking = new URLSearchParams();
  for (const key of TRACKING_KEYS) {
    const value = source.get(key);
    if (value) tracking.set(key, value.slice(0, 120));
  }
  const query = tracking.toString();
  return `/tour/${citySlug.toLowerCase()}${query ? `?${query}` : ""}`;
}
